import { render, staticRenderFns } from "./ParametrizacaoModal.vue?vue&type=template&id=2cfdc73a&scoped=true"
import script from "./ParametrizacaoModal.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoModal.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoModal.vue?vue&type=style&index=0&id=2cfdc73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfdc73a",
  null
  
)

export default component.exports